import axios from "axios";

const UserService = {
    async getUserDetails(userId) {
        const response = axios.get(`/api/user/${userId}`);
        return response;
    },

    async saveUser(user) {
        const response = axios.put(`/api/user/`, user);
        return response; 
    },

    async createUser(user) {
        const response = axios.post(`/api/user/`, user);
        return response;
    },

    async changePassword(userPasswordChangeSet) {
        const response = axios.post(`/api/user/changePassword`, userPasswordChangeSet);
        return response;
    },

    async getRoles(userType, organizationId) {
        const response = axios.get(`/api/user/roles?userType=${userType}&organizationId=${organizationId}`);
        return response;
    },

    async getPotentialSpmWebUsers(orgId) {
        const response = axios.get(`/api/user/potentialSpmWebUsers/${orgId}`);
        return response;
    },

    async importSpmLocalUser(orgId, spmLocalUserIds, roleIds){
        const response = axios.post(`/api/user/importSpmLocal/`, {
            orgId,
            spmLocalUserIds,
            roleIds
        });
        return response;
    },
}

export default UserService; 
